(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyDriveawayPriceIsolateScope", function () {
    return {
      scope: true,
      restrict: "A",
    };
  });
})(window.angular);
